import useAgentData from "../../utils/hooks/useAgentData";
import AIsuggestions from "./AIsuggestions";

const formatInteractionHistory = (data) =>
  data.map((item, index) => ({
    username: item.type,
    message: item.summary,
    icon:
      {
        "Chat Session": "/icons/blue-chat.png",
        "Phone Call": "/icons/green-call.png",
        Email: "/icons/purple-mail.png",
      }[item.type] || "/icons/default.png",
    bgColor:
      {
        "Chat Session": "bg-[#DBEAFE]",
        "Phone Call": "bg-[#DCFCE7]",
        Email: "bg-[#F3E8FF]",
      }[item.type] || "bg-gray-200",
    date: item.timestamp,
  }));

const InteractionHistory = () => {
  const { interactionHistory, loading } = useAgentData();

  if (loading || !interactionHistory) return null;

  const InteractionHistoryItems = formatInteractionHistory(interactionHistory);

  return (
    <div className="flex flex-col items-start w-full h-full gap-4 bg-white">
      <div className="w-full h-[22px] border-b border-[#0000002B]  flex items-start">
        <h1 className="h-[24px] pl-2 text-[13px] font-semibold leading-[100%] text-black font-inter">
          Interaction History
        </h1>
      </div>

      {InteractionHistoryItems.map((item, index) => (
        <div
          key={index}
          className="flex flex-col items-start w-full gap-1 px-3"
        >
          <div className="flex flex-row items-start w-full gap-1">
            <div
              className={`w-[28px] h-[28px] ${item.bgColor} rounded-full flex items-center justify-center`}
            >
              <img
                src={item.icon}
                alt="icon"
                className="object-contain w-[15px] h-[15px]"
              />
            </div>

            <div className="flex flex-col w-full">
              <div className="flex items-start justify-between w-full">
                <span className="text-[11px] font-inter leading-[100%] text-black">
                  {item.username}
                </span>
                <span className="text-[9px] font-inter leading-[100%] text-[#00000073] text-opacity-80">
                  {item.date}
                </span>
              </div>
              <div className="text-[9px] py-1 font-inter text-[#00000073] text-opacity-80">
                {item.message}
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="text-[#A859FE] px-4 w-full border-b border-[#0000002B] pb-2">
        <span className="font-inter font-medium text-[12px] leading-[100%] tracking-[0%]">
          View All History
        </span>
      </div>

      <div className="flex flex-grow w-full ">
        <AIsuggestions />
      </div>
    </div>
  );
};

export default InteractionHistory;
